import type { SurveyListItem } from '@lms/api-client/backend';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@lms/ui/table';
import { Link } from 'react-router-dom';
import { useTranslations } from 'use-intl';
import { DeleteConfirmationMenu } from '@/components/delete-confirmation-menu';
import { removeSurvey } from '@/features/survey/survey-admin-api';

// Ports features/survey/components/survey-list.tsx. The Next `TableListView`
// (with its built-in delete action and `router.refresh`) becomes a table using
// the shared `DeleteConfirmationMenu`; deletion revalidates via `onChanged`.
export default function SurveyList({
  surveys,
  slug,
  onChanged,
}: {
  surveys: SurveyListItem[];
  slug: string;
  onChanged: () => void;
}) {
  const t = useTranslations('admin');

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>{t('name')}</TableHead>
          <TableHead></TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {surveys.map((survey) => (
          <TableRow key={survey.id}>
            <TableCell>
              <Link to={`/${slug}/admin/surveys/${survey.id}`}>
                {survey.name}
              </Link>
            </TableCell>
            <TableCell className="text-right">
              <DeleteConfirmationMenu
                id={survey.id}
                onDelete={removeSurvey}
                onDeleted={onChanged}
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
